if (!customElements.get('ez-payment-choice')) {
  customElements.define('ez-payment-choice', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.total = Number(this.dataset.total);
      this.money = new Intl.NumberFormat('es-AR', { style: 'currency', currency: this.dataset.currency || 'ARS' });
      this.summary = this.closest('#cart-drawer-summary, .cart-summary') || this.parentElement;
      this.hideScalaButton();
      this.scalaObserver = new MutationObserver(() => this.hideScalaButton());
      this.scalaObserver.observe(this.summary, { childList: true });
      this.querySelector('[data-ez-payment-open]').addEventListener('click', () => {
        this.querySelector('input[value="card"]').checked = true;
        this.updateTotal();
        this.dialog.showModal();
      });
      this.querySelector('[data-ez-payment-close]').addEventListener('click', () => this.dialog.close());
      this.querySelectorAll('input').forEach(input => input.addEventListener('change', () => this.updateTotal()));
      this.querySelector('[data-ez-payment-continue]').addEventListener('click', () => this.checkout());
      this.resetCheckout = () => {
        this.checkingOut = false;
        this.querySelector('[data-ez-payment-continue]').disabled = false;
      };
      window.addEventListener('pageshow', this.resetCheckout);
    }
    disconnectedCallback() {
      this.scalaObserver?.disconnect();
      window.removeEventListener('pageshow', this.resetCheckout);
    }
    hideScalaButton() {
      this.summary.querySelectorAll('scala-cart-button').forEach(host => {
        if (host.closest('[data-ez-scala-hidden]')) return;
        const wrapper = document.createElement('div');
        wrapper.hidden = true;
        wrapper.dataset.ezScalaHidden = '';
        wrapper.setAttribute('aria-hidden', 'true');
        host.before(wrapper);
        wrapper.append(host);
      });
    }
    updateTotal() {
      const transfer = this.querySelector('input:checked').value !== 'card';
      this.querySelector('[data-ez-payment-total]').textContent = this.money.format(Math.round(this.total * (transfer ? 0.75 : 1)) / 100);
      this.querySelector('[data-ez-payment-saving]').hidden = !transfer;
      this.querySelector('[data-ez-payment-error]').hidden = true;
    }
    async checkout() {
      if (this.checkingOut) return;
      const phone = this.querySelector('[data-ez-order-phone]');
      if (!phone) return;
      phone.setCustomValidity('');
      const digits = phone.value.replace(/\D/g, '');
      if (digits.length < 7 || digits.length > 15 || !/^[+\d\s().-]+$/.test(phone.value.trim())) {
        phone.setCustomValidity('Ingresá un teléfono válido con código de área.');
      }
      if (!phone.reportValidity()) return;
      const nextButton = this.querySelector('[data-ez-payment-continue]');
      this.checkingOut = true;
      nextButton.disabled = true;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Teléfono de contacto': phone.value.trim() } })
        });
        if (!response.ok) throw new Error('No se pudo guardar el teléfono.');
      } catch (failure) {
        const error = this.querySelector('[data-ez-payment-error]');
        error.textContent = 'No pudimos guardar tu teléfono. Volvé a intentarlo antes de continuar.';
        error.hidden = false;
        this.checkingOut = false;
        nextButton.disabled = false;
        return;
      }
      this.checkingOut = false;
      nextButton.disabled = false;
      const summary = this.closest('#cart-drawer-summary, .cart-summary') || this.parentElement;
      if (this.querySelector('input:checked').value !== 'card') {
        const scalaHost = summary.querySelector('scala-cart-button');
        const scalaButton = scalaHost?.shadowRoot?.querySelector('#scala-button');
        if (!scalaButton) {
          const error = this.querySelector('[data-ez-payment-error]');
          error.textContent = 'La opción con descuento todavía está cargando. Volvé a intentarlo en unos segundos.';
          error.hidden = false;
          return;
        }
        scalaButton.click();
      } else {
        const continueButton = this.querySelector('[data-ez-payment-continue]');
        this.checkingOut = true;
        continueButton.disabled = true;
        try {
          if (Number(this.dataset.paymentDiscount) > 0) {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: this.dataset.otherCodes || '' })
            });
            if (!response.ok) throw new Error('No se pudo actualizar el medio de pago.');
          }
          summary.querySelector('[data-ez-native-checkout]').click();
        } catch (failure) {
          const error = this.querySelector('[data-ez-payment-error]');
          error.textContent = 'No pudimos actualizar el pago. Volvé a intentarlo.';
          error.hidden = false;
          this.checkingOut = false;
          continueButton.disabled = false;
        }
      }
    }
  });
}
